import { Component } from '@angular/core'
import { IconLegacyComponent, TooltipModule } from '@ftr/foundation'
import { LogoTheme } from '../../types'
import { FtrLogoComponent } from '../ftr-logo'
@Component({
  selector: 'ftr-header-logged-out',
  templateUrl: './header-logged-out.component.html',
  styleUrls: ['./header-logged-out.component.css'],
  imports: [FtrLogoComponent, TooltipModule, IconLegacyComponent],
})
export class HeaderLoggedOutComponent {
  readonly logoThemes = LogoTheme
}
